export const TriggerCategoryList = [
  {
    categoryId: 1,
    categoryName: 'child abuse material',
  },
  {
    categoryId: 2,
    categoryName: 'darknet market',
  },
  {
    categoryId: 3,
    categoryName: 'sanctioned entity',
  },
  {
    categoryId: 4,
    categoryName: 'no kyc exchange',
  },
  {
    categoryId: 6,
    categoryName: 'stolen funds',
  },
  {
    categoryId: 7,
    categoryName: 'mining pool',
  },
  {
    categoryId: 9,
    categoryName: 'other',
  },
  {
    categoryId: 10,
    categoryName: 'ethereum contract',
  },
  {
    categoryId: 11,
    categoryName: 'hosted wallet',
  },
  {
    categoryId: 12,
    categoryName: 'ransomware',
  },
  {
    categoryId: 13,
    categoryName: 'mixing',
  },
  {
    categoryId: 14,
    categoryName: 'ico',
  },
  {
    categoryId: 15,
    categoryName: 'erc20 token',
  },
  {
    categoryId: 16,
    categoryName: 'gambling',
  },
  {
    categoryId: 17,
    categoryName: 'merchant services',
  },
  {
    categoryId: 18,
    categoryName: 'scam',
  },
  {
    categoryId: 19,
    categoryName: 'p2p exchange',
  },
  {
    categoryId: 20,
    categoryName: 'none',
  },
  {
    categoryId: 21,
    categoryName: 'exchange',
  },
  {
    categoryId: 22,
    categoryName: 'mining',
  },
  {
    categoryId: 23,
    categoryName: 'terrorist financing',
  },
  {
    categoryId: 24,
    categoryName: 'atm',
  },
  {
    categoryId: 25,
    categoryName: 'sanctioned jurisdiction',
  },
  {
    categoryId: 26,
    categoryName: 'lending',
  },
  {
    categoryId: 27,
    categoryName: 'decentralized exchange',
  },
  {
    categoryId: 28,
    categoryName: 'fraud shop',
  },
  {
    categoryId: 29,
    categoryName: 'illicit actor-org',
  },
  {
    categoryId: 30,
    categoryName: 'infrastructure as a service',
  },
  {
    categoryId: 31,
    categoryName: 'token smart contract',
  },
  {
    categoryId: 32,
    categoryName: 'smart contract',
  },
  {
    categoryId: 33,
    categoryName: 'protocol privacy',
  },
  {
    categoryId: 34,
    categoryName: 'special measures',
  },
  {
    categoryId: 35,
    categoryName: 'malware',
  },
  {
    categoryId: 36,
    categoryName: 'drug vendor',
  },
  {
    categoryId: 37,
    categoryName: 'bridge',
  },
  {
    categoryId: 38,
    categoryName: 'nft platform - collection',
  },
  {
    categoryId: 39,
    categoryName: 'seized funds',
  },
  {
    categoryId: 41,
    categoryName: 'unnamed service',
  },
  {
    categoryId: 42,
    categoryName: 'stolen bitcoins',
  },
  {
    categoryId: 43,
    categoryName: 'stolen ether',
  },
  {
    categoryId: 45,
    categoryName: 'escort service',
  },
  {
    categoryId: 46,
    categoryName: 'instant exchange',
  },
  {
    categoryId: 47,
    categoryName: 'institutional platform',
  },
  {
    categoryId: 999,
    categoryName: 'custom address',
  },
];
